import { render, staticRenderFns } from "./JZ.vue?vue&type=template&id=83041698&scoped=true&"
import script from "./JZ.vue?vue&type=script&lang=js&"
export * from "./JZ.vue?vue&type=script&lang=js&"
import style0 from "./JZ.vue?vue&type=style&index=0&id=83041698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83041698",
  null
  
)

export default component.exports